export default {"src":"/_next/static/media/logo-no-text.a1a02b2b.svg","height":114,"width":114};